// Links into the ni-datapipe app, where passive implants are authored.
// REACT_APP_DATAPIPE_URL is compiled in at build time. A development build
// falls back to the datapipe's local dev port; a production build without the
// variable hides every datapipe link.
const PASSIVE_IMPLANTS_PATH = '/passive-implants';
const LOCAL_DATAPIPE_URL = 'http://localhost:3001';

const getDatapipeBaseUrl = (): string | null => {
    const configured = process.env.REACT_APP_DATAPIPE_URL?.trim();
    if (configured) return configured.replace(/\/+$/, '');
    return process.env.NODE_ENV === 'development' ? LOCAL_DATAPIPE_URL : null;
};

export const getDatapipeImplantEditUrl = (implantId: string): string | null => {
    const baseUrl = getDatapipeBaseUrl();
    if (!baseUrl || !implantId) return null;
    return `${baseUrl}${PASSIVE_IMPLANTS_PATH}/${encodeURIComponent(implantId)}/edit`;
};

export const getDatapipeImplantViewUrl = (implantId: string): string | null => {
    const baseUrl = getDatapipeBaseUrl();
    if (!baseUrl || !implantId) return null;
    return `${baseUrl}${PASSIVE_IMPLANTS_PATH}/${encodeURIComponent(implantId)}`;
};

export const getDatapipeNewImplantUrl = (): string | null => {
    const baseUrl = getDatapipeBaseUrl();
    if (!baseUrl) return null;
    return `${baseUrl}${PASSIVE_IMPLANTS_PATH}/new`;
};
